<template>
  <div
    class="row"
    :class="$style.row"
  >
    <div class="col-12 text-center">
      <g-project-logo
        :dark="true"
        class="mb-5"
      />

      <div :class="$style.form">
        <a-tabs
          v-model="tab"
          default-active-key="1"
          class="hidden-tabs"
        >
          <a-tab-pane
            :key="1"
            tab="Tab 1"
          >
            <request
              v-model="username"
              @next="tab = 2"
            />
          </a-tab-pane>
          <a-tab-pane
            :key="2"
            tab="Tab 2"
            force-render
          >
            <change
              v-model="username"
              @back="tab = 1"
            />
          </a-tab-pane>
        </a-tabs>
      </div>
      <terms />
    </div>

    <div :class="$style.bg" />
  </div>
</template>

<script>
import request from './steps/1';
import change from './steps/2';

export default {
	name: 'ForgotPassword',
	components: {
		request,
		change
	},
	data() {
		return {
			tab: 1,
			username: ''
		};
	},
	watch: {
		tab(val) {
			if (val === 2 && this.username === '') this.tab = 1;
		}
	},
	created() {
		let username = '';

		if (this.$gestios.profile.Email) username = this.$gestios.profile.Email;
		if (this.$gestios.profile.Nick) username = this.$gestios.profile.Nick;

		this.username = username;

		if (this.username === '') this.tab = 1;
	}
};
</script>

<style lang="scss" module>
	.form{
		background: white;
		height: 100%;
		justify-content: center;
		display: flex;
		flex-direction: column;
		max-width: 500px;
		padding: 60px;
		border-radius: 20px;
		margin: 0 auto 40px  auto;
	}

	.bg{
		background: url('../../../../assets/images/public/restore-bg.jpg') no-repeat center center;
		background-size: cover;
		position: fixed;
		width: calc(100% + 80px);
		height: calc(100% + 80px);
		left: 0;
		top: 0;
		z-index: -1;
		margin: -40px;
		filter: blur(8px);
		-webkit-filter: blur(8px);
	}

	.row{
		background-size: auto 100%;
		height: 100vh;
		align-items: center;
		display: flex;
	}

	@media (max-width: $sm-min-width) {
		.form{
			padding: 30px;
		}
	}

	[data-kit-theme='dark'] {
		.form{
			background: $dark;
		}
	}

</style>
